import { useCallback, useRef, useState } from 'react'
import useCopyToClipboard from 'hooks/useCopyToClipboard'

const DEFAULT_RESET_MS = 1500

function useCopyWithFeedback(value: string, resetMs = DEFAULT_RESET_MS) {
  const [isCopied, setIsCopied] = useState(false)
  const [, copy] = useCopyToClipboard()
  const timerRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)

  const handleCopy = useCallback(async() => {
    if (isCopied) return
    const success = await copy(value)
    if (success) {
      setIsCopied(true)
      clearTimeout(timerRef.current)
      timerRef.current = setTimeout(() => setIsCopied(false), resetMs)
    }
  }, [value, copy, isCopied, resetMs])

  return { isCopied, handleCopy }
}

export default useCopyWithFeedback
